import { FlexDiv, H1, P } from '../generic/HomePageComponents.js'

const AboutUs = ({ data: { header, bodyCopy } }) => (
  <FlexDiv flexDirection='column' alignItems='center'>
    <H1 fontSize='36px' mb='10px'>
      {header}
    </H1>
    <P
      fontSize='19px'
      lineHeight='28.5px'
      textAlign='center'
      maxWidth={{ _: '80vw', desktop: '700px' }}
    >
      {bodyCopy}
    </P>
  </FlexDiv>
)
export default AboutUs
